export default __webpack_public_path__ + "static/media/19.d6b25ad5.jpg";